/*
 * @Descripttion: 高性能动态增删form表单
 * @Author: 郑泳健
 * @Date: 2023-02-16 10:43:03
 * @LastEditors: 郑泳健
 * @LastEditTime: 2023-04-06 15:32:07
 */
import React, { useState, useRef } from 'react'
import { validateFields, getFieldsValue, getFieldValue } from './utils'
import { FormContext } from './store'
import type { IForm, ITntdFormProps, IObject, TinitialValueType, IUpdateObj } from './interface'
import List from './components/List'
import Item from './components/Item'

const TntdForm = ({ form, initialValues, children }: ITntdFormProps) => {
  const updateRefs = useRef<IUpdateObj>({
    shouldUpdateList: [],
    dependencies: {},
  })

  const compsRefs = useRef({})

  return (
    <FormContext.Provider
      value={{
        form,
        initialValues,
        updateRefs,
        compsRefs,
      }}
    >
      {children}
    </FormContext.Provider>
  )
}

TntdForm.useForm = () => {
  const form: { current: IForm } = useRef<IForm>({
    dataLevel: {},
    formData: {},
    validateFields: () => validateFields(form.current),
    getFieldsValue: () => getFieldsValue(form.current),
    getFieldValue: (field: Array<string>) => getFieldValue(form.current, field),
    setFieldsValue: (obj: IObject<TinitialValueType>) => {
      for (const i in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, i)) {
          const prefix = i?.split('.') || []
          const attr = prefix.pop()
          if (attr && form.current.formData[prefix.join('.')][attr]) {
            form.current.formData[prefix.join('.')][attr].setItemValue(obj[i])
          }
        }
      }
    },
  })

  return [form.current]
}

TntdForm.List = List
TntdForm.Item = Item

export default TntdForm
